import { AppBar, Box, Tab, Tabs, Toolbar } from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import { generateGtmEvent } from "../../../Helpers";

const useStyles = makeStyles((theme) => ({
  tabs: {
    "& .MuiTab-root": {
      color: theme.palette.text.primary,
      fontSize: 18,
    },
  },
  root: {
    height: 72,
    boxSizing: "border-box",
    paddingLeft: 32,
    paddingRight: 32,
    maxWidth: "1280px",
    width: "100%",
  },
  tab: {
    height: 72,
  },
}));

export interface AvailableTabs {
  label: string;
  id: string;
  route: string;
  defaultSort: string;
  isHidden?: boolean;
  heading: string;
}

interface UserManagementMenuProps {
  value: number;
  availableTabs: AvailableTabs[];
  handleChange: (event: React.SyntheticEvent, newValue: string, newSort: string) => void;
}

export const UsersTabMenu = (props: UserManagementMenuProps) => {
  const classes = useStyles();
  const { value, availableTabs, handleChange } = props;
  const HandleDataLayer = (text: string) => {
    generateGtmEvent({
      event: "link",
      action: "click",
      name: "onclick",
      type: "internal link",
      region: "main content",
      section: "secondary navbar",
      text: text,
    });
  };
  return (
    <AppBar
      sx={{ alignItems: "center", borderBottom: `2px solid #dedede` }}
      position="static">
      <Toolbar disableGutters className={classes.root} tabIndex={-1}>
        <Box sx={{ flexGrow: 1 }}>
          <Tabs className={classes.tabs} value={value} aria-label="basic tabs example">
            {availableTabs.map((tab, index) => {
              if (tab.isHidden) {
                return null;
              }
              return (
                <Tab
                  className={classes.tab}
                  key={tab.id}
                  label={tab.label}
                  value={index}
                  onClick={(e) => {
                    HandleDataLayer(tab.label);
                    handleChange(e, tab.route, tab.defaultSort);
                  }}
                />
              );
            })}
          </Tabs>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
